import 'regenerator-runtime/runtime';
import _ from 'lodash';
import { call, put, select } from 'redux-saga/effects';

import API, { methods } from '../../canvas-api';
import { handleGenericError, getSlicerState } from '../../common';
import { actions } from '../../../reducers/slicer/slicer';

const combineMaterials = (newMaterial, existingMaterials) => ({
  ...existingMaterials,
  [newMaterial.id]: newMaterial,
});

export default function* createMaterial(action) {
  try {
    const { materials: existingMaterials } = yield select(getSlicerState);
    const { material } = action.payload;
    const body = _.omit(material, 'id');

    const response = yield call(API, {
      method: methods.PUT,
      path: 'materials',
      body,
    });
    if (response === null) return;

    const combinedMaterials = combineMaterials(
      response.material,
      existingMaterials
    );
    yield put(actions.createMaterialSuccess(combinedMaterials));
  } catch (e) {
    yield call(handleGenericError, action, e);
  }
}
